import { render, staticRenderFns } from "./TableMove.vue?vue&type=template&id=3d265f1d"
import script from "./TableMove.vue?vue&type=script&lang=js"
export * from "./TableMove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports